import React from 'react';

import { flagStyles } from '../settings';

const SvgBT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-744px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgBT;
